import { motion, useReducedMotion } from 'framer-motion'
import { SPRING } from '../../utils/motion'

/* ── Button ────────────────────────────────────────────────────────────────
   Material pill buttons. The filled one is lit (`.btn-lit`: a top-lit
   gradient, a highlight edge, a coloured shadow) and lifts a pixel on hover;
   all of them carry a state layer and press in slightly. (The name is kept
   from the earlier kinetic system.) */

const VARIANTS = {
  filled: 'btn-lit text-primary-on',
  tonal: 'bg-primary-container text-primary-on-container',
  ink: 'bg-secondary text-secondary-on',
  canvas: 'bg-canvas text-ink',
  outlined: 'bg-sc-lowest/70 text-ink border border-outline shadow-[inset_0_1px_0_rgb(var(--highlight)),var(--elev-1)] backdrop-blur hover:border-ink-3',
  text: 'bg-transparent text-primary',
}

const SIZES = {
  sm: 'h-10 px-4 text-sm gap-1.5',
  md: 'h-11 px-5 text-sm gap-2',
  lg: 'h-12 px-7 text-[15px] gap-2.5',
}

export default function KineticButton({ as = 'button', variant = 'filled', size = 'md', className = '', children, ...props }) {
  const reduce = useReducedMotion()
  const Tag = motion[as] || motion.button
  return (
    <Tag
      whileTap={reduce ? undefined : { scale: 0.98 }}
      transition={SPRING.snappy}
      className={`state-layer inline-flex select-none items-center justify-center whitespace-nowrap rounded-full font-semibold tracking-tight transition-[border-color,box-shadow] duration-200
                  ${VARIANTS[variant]} ${SIZES[size]} ${className}`}
      {...props}
    >
      {children}
    </Tag>
  )
}
